import React, { Fragment, ReactNode, useEffect } from 'react';
import { Field, Formik, FormikHelpers } from 'formik';
import styled from 'styled-components';
import { Button } from 'primereact/button';
import { ObjectSchema } from 'yup';
import theme from '../../helpers/theme';

export interface IFormInput {
	name: string;
	options?: object;
	icon?: ReactNode;
	placeholder: string;
	hasAdd?: boolean;
	addToList?: () => void;
	as: any;
}

export interface IFormValues {
	[key: string|number|boolean]: string|number|boolean; // Define a string type for each key in the object
}

interface IForm {
	initialValues: IFormValues; // Use the IFormValues interface to define the type of initialValues
	initialSchema: ObjectSchema<any>;
	AfterSubmitButton?: ReactNode;
	BeforeSubmitButton?: ReactNode;
	onSubmitFunction: (values: IFormValues, formikHelpers: FormikHelpers<IFormValues>) => void; // Update the type of onSubmitFunction to use IFormValues
	loading: boolean;
	enableReinitialize?: boolean;
	formInputs: Array<IFormInput>;
	submitButtonIcon?: ReactNode;
	submitButtonText?: string;
	onInputChange?: (field: string, value: string) => any;
	validateOnMount?: boolean;
}


const defaultProps = {
	validateOnMount: true,
	submitButtonText: 'Submit',
	options: {},
};

const CustomForm = ({ initialValues, initialSchema, AfterSubmitButton, BeforeSubmitButton, onSubmitFunction, loading, onInputChange, enableReinitialize, validateOnMount, formInputs, submitButtonText,}: IForm) => {

	return (
	 <>
		 <Formik
			validateOnMount={validateOnMount}
			enableReinitialize={enableReinitialize}
			initialValues={initialValues}
			validationSchema={initialSchema}
			submitButtonText={submitButtonText}
			validateOnChange
			validateOnBlur
			onSubmit={onSubmitFunction}
		 >
			 {({
					 errors,
					 setFieldTouched,
					 values,
					 setFieldValue,
					 touched,
					 handleBlur,
					 handleSubmit,
					 isValid
				 }) => (
				<Form onSubmit={handleSubmit}>
					{formInputs.map(({ name, icon, placeholder, as, options,hasAdd,addToList }) =>
					 <Fragment key={name}>
						 <Field
							key={name}
							errors={errors}
							onBlur={handleBlur}
							touched={touched}
							options={options}
							value={values[name]} // Access the value directly from the values object
							onChange={(field: string, value: string) => {
								setFieldTouched(field, true);
								setFieldValue(field, value);
								onInputChange?.(field, value)
							}}
							icon={icon}
							as={as}
							{...options}
							placeholder={placeholder}
							name={name}
							hasAdd={hasAdd}
							addToList={addToList}
						 />


						 </Fragment>)}
					<>
						{BeforeSubmitButton}
						<FormButtonStyle>
							<Button label={submitButtonText} loading={loading} disabled={!isValid} style={{ background: "#66009b", width: '100%', height: '2.8em', color: theme.white,borderRadius:theme.radius,display:"flex",alignItems:"center",justifyContent:"center"}} className="p-button-raised" type="submit" />

						</FormButtonStyle>
						{AfterSubmitButton}
					</>
				</Form>
			 )}
		 </Formik>
	 </>
	);
};
CustomForm.defaultProps = defaultProps;
const FormButtonStyle = styled.div`
  
  display: flex;
  justify-content: center;
  align-items: center;
	width:100%;
`;
const Form = styled.form`
 display: flex;
 min-width: 100%;
	max-width:100%;
 flex-direction: column;

`

export default CustomForm;
